import { Injectable } from '@angular/core';
import { AbsentismoDiario } from 'app/modules/common/entities/absentismodiario.model';
import { AbsentismoMensual } from 'app/modules/common/entities/absentismomensual.model';
import { RestResponse } from 'app/modules/common/entities/rest.response.generic.model';
import { ApiService } from 'app/modules/common/services/api.service';
import { DateTimeUtilsService } from 'app/modules/common/services/date-time-utils-service.service';
import { Moment } from 'moment';
import { Observable } from 'rxjs';
import API from '../../../modules/common/services/api.config.json';

@Injectable({
    providedIn: 'root'
})
export class CompanyDashboardService {

    constructor(
        private apiService: ApiService,
        private dateTimeUtils: DateTimeUtilsService,
    ) { }


    /**
     * Get AbsentismMensual data for the given empressa ID, month and year
     */
    getAbsentismMensualData = (empressaId: number, year: number, month: number): Observable<RestResponse<AbsentismoMensual>> => {

        // build URL
        const url = (API.CompanyManagement.getAbsentismoMensual as string)
            .replace("{empressaId}", empressaId.toString())
            .replace("{year}", year.toString())
            .replace("{month}", (month + 1).toString());

        // call API
        return this.apiService.get(url);

    };


    /**
     * Get AbsentismoDiario data for the given empressa ID and date
     */
    getAbsentismoDiariolData = (empressaId: number, date: Moment): Observable<RestResponse<AbsentismoDiario>> => {

        const dateStr = this.dateTimeUtils.convertMomentFormBackend(date);

        // build URL
        const url = (API.CompanyManagement.getAbsentismoDiario as string)
            .replace("{empressaId}", empressaId.toString())
            .replace("{fecha}", dateStr);

        // call API
        return this.apiService.get(url);

    };


    /**
     * Get AbsentismoDiario for the given period
     * @returns Absentismo Diario data for the given period
     */
    getAbsentismoDiarioDataForPeriod = (empressaId: number, startDate: Moment, endDate: Moment): Observable<RestResponse<AbsentismoDiario[]>> => {

        const startDateStr = this.dateTimeUtils.convertMomentFormBackend(startDate);
        const endDateStr = this.dateTimeUtils.convertMomentFormBackend(endDate);

        // build URL
        const url = (API.CompanyManagement.getAbsentismoDiarioForPeriod as string)
            .replace("{empressaId}", empressaId.toString())
            .replace("{startDate}", startDateStr)
            .replace("{endDate}", endDateStr);

        // call API
        return this.apiService.get(url);

    };


    /**
     * Get monthly absentism data for years
     * @param fromBegining If true, data will be recieved from begining of the start year (startYear = currentYear - noOfYears)
     * @returns Monthly absentism data for given number of years previous to current date
     */
    getAbsentismoMensualDataForYears = (empressaId: number, noOfYears: number, fromBegining: boolean): Observable<RestResponse<AbsentismoMensual[]>> => {

        // build URL
        const url = (API.CompanyManagement.getAbsentismoMensualForYears as string)
            .replace("{empressaId}", empressaId.toString())
            .replace("{noOfYears}", noOfYears.toString())
            .replace("{fromBegining}", fromBegining.toString());

        // call API
        return this.apiService.get(url);

    };


    /**
     * Convert null values of integer properties in API results into 0  
     * Properties those are expected to have integer values should not be null. If any of those property is null, it is assigned 0
     * @param obj Object
     */
    public convertNullNumbersToZero = (obj: any) => {
        // go through each property and assign zero to null integer properties
        for (const key in obj) {
            if (key !== "desde" && key !== "hasta") // desde and hasta are not integer properties
                obj[key] = obj[key] ?? 0;
        }
    };

}
